module.exports = __webpack_public_path__ + "img/gardens-of-the-hesperides.470362b4.jpg";